/*@ngInject*/
const ReferralRepository = function (baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.declineReferral = function (submissionId, comments, doDecline) {
        var url = '/rest/Submission/' + submissionId + '/Referral',
            body = {
                detail: comments,
                doDecline: doDecline,
                notification: notificationConstant.email.NONE
            };
        return this.post(url, body);
    };

    this.clearReferral = function (submissionId, detail, doDecline) {
        var url = '/rest/Submission/' + submissionId + '/Referral',
            body = {
                detail: detail,
                doDecline: doDecline,
                notification: notificationConstant.email.NONE
            };
        return this.post(url, body);
    };

    this.retractReferral = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/retractReferral',
            body = {
                reason: reason,
                detail: detail,
                notification: notificationConstant.email.NONE
            };
        return this.post(url, body);
    };

    this.getReferralClearanceType = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/referralClearanceType';

        return this.get(url);
    };

};

angular.module('gw-um-submission')
    .service('referralRepository', ReferralRepository);
